(function($) {
  $.fn.pointOut = function(title, description, adjust_position, callback) {
    var goleft = this.offset().left < $(document).width()/2;
    
    if(!description) description = '';
    var popup = $('<div class="pointer" style="'+(goleft ? 'text-align:left' : 'text-align:right') +'"><h2>' + (goleft ? '&larr; '+title : title + ' &rarr;') + '</h2><p>'+description+'</p></div>');
    $('body').prepend(popup);
    popup.hide();

    var offset = this.offset();

    var ot,ol,adjust_x,adjust_y;
    
    if (adjust_position instanceof Array) {
      adjust_y = adjust_position[0];
      adjust_x = adjust_position[1];
    } else if (adjust_position != null) {
      adjust_y = adjust_position;
      adjust_x = 0;
    } else {
      adjust_y = 0;
      adjust_x = 0;
    }

    ot = offset.top + adjust_y;
    ol = offset.left + adjust_x;

    if (ot > $(window).height()-70) {
      ot = $(window).height()-70;
      $(this).closest('.overflowing').scrollTo(ot, 200);
    } else if (ot < 32) {
      ot = 42;
      $(this).closest('.overflowing').scrollTo(0, 200);
    }
    
    if(goleft) {
      popup.css({top:0, left: ol + this.outerWidth() + 208})
      popup.animate({top: ot - 50, left: ol + this.outerWidth() + 208, opacity:"show"}, 500);
      popup.animate({top: ot - 10, left: ol + this.outerWidth() + 3}, 400);
    } else {
      popup.css({top:0, left: ol - popup.outerWidth() - 208})
      popup.animate({top: ot - 50, left: ol - popup.outerWidth() - 208, opacity:"show"}, 500);
      popup.animate({top: ot - 10, left: ol - popup.outerWidth() - 3}, 400);
    }
    setTimeout(function() { popup.fadeOut(function(){$(this).remove()}); }, 3000);
    if(callback)
      setTimeout(callback, 1500)
    return false;
  };
})(jQuery);



// WEBPACK FOOTER //
// ./public/javascripts/jquery/jquery.pointout.js